import {ElementRef, Renderer2} from '@angular/core';
import * as Popper from 'popper.js/dist/umd/popper';
import * as moment from 'moment';
import {SlickGridComponent} from "../../slick-grid/slick-grid.component";
import {GUID} from "./GUID-interface";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {TranslateService} from "@ngx-translate/core";
import {Aggregation, AggregationSelector} from "../../stocks/models/aggregation-selector";
import {CommonDataService} from "../../services/common-data.service";
import {DialogOptions} from "./dialogOptions";
import {Formatters} from "../../slick-grid/models/formatters";
import {IndentSize} from "./Indent-size";
import {TooltipOption} from "bootstrap";
import {EventArgs} from "../../slick-grid/models/event-args";
import {LocalizationCorrespondence} from "./localization-correspondence";
import {DataSorter} from "../../slick-grid/models/data-sorter";
import {ExportExcelColumn} from "./export-excel-column";
import {Fresh} from './fresh';
import {ActionPlusExcelChecked} from "../../buffer-table/models/checkedTable";
import {IPMainData} from "../../item-properties/models/i-p-main-data";
import CellCssStylesHash = Slick.CellCssStylesHash;

export class MainHelper {
    constructor(
    ) {

    }

    //# upgrade setTimeout function, clear memory after use
    public readonly wait = (func: Function, milliseconds: number = 1): void => {
        let timeout = setTimeout(() => {
            clearTimeout(timeout);
            timeout = null;
            func();
        }, milliseconds)
    };

    public static readonly stWait = (func: Function, milliseconds: number = 1): void => {
        let timeout = setTimeout(() => {
            clearTimeout(timeout);
            timeout = null;
            func();
        }, milliseconds)
    };

    public readonly sleep = (ms: number): Promise<void> => new Promise(resolve => this.wait(resolve, ms));

    public static readonly stSleep = (ms: number): Promise<void> => new Promise(resolve => MainHelper.stWait(resolve, ms));

    public readonly waitInterval = (func: () => boolean, milliseconds: number = 1): void => {
        let interval = setInterval(() => {
            if (func()) {
                clearInterval(interval);
                interval = null;
            }
        }, milliseconds)
    };

    //# generate unique number
    public readonly generateGUID = (): string => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,(c, r) => ('x' == c ?( r = Math.random()*16|0):(r&0x3|0x8)).toString(16))
    };

    /**
     * Gen random number
     * @param min
     * @param max
     */
    public readonly randomIntFromInterval = (min: number, max: number): number => {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }


    //# defines was click inside mainWrapper, if was not return true
    public readonly hideList = (mainWrapper: ElementRef | HTMLElement ,e: MouseEvent, renderer: Renderer2, text?: string): boolean => {

        let hideMenu: boolean = true;

        let wrpEl: HTMLElement = mainWrapper && (mainWrapper as ElementRef).nativeElement ? (mainWrapper as ElementRef).nativeElement : mainWrapper;

        let el = e.target;
        while (el){
            if (wrpEl && wrpEl.isSameNode(el as HTMLElement)){
                hideMenu = false;
                // text ? console.log(e, el, hideMenu, wrpEl, 'hideList ' + text) : null;
                break;
            }
            // text ? console.log(e, el, hideMenu, wrpEl, 'hideList ' + text) : null;
            let oldEl: HTMLElement = el as any;
            el = renderer.parentNode(el);
            // text && !el ? console.log(e, el, oldEl, oldEl.parentElement, oldEl.parentNode, hideMenu, 'hideList ' + text) : null;
        }
        return hideMenu;
    };

    //# search text in string, if find return true
    public readonly matchText = (searched: string[], data: string, every: boolean = true): boolean =>{
        if (!data) return false;
        let result: boolean [] = [];
        searched.forEach(item =>{
            result.push(item ? data.toLowerCase().indexOf(item.toLowerCase()) > -1 : true);
        });

        return every ? result.every(item => item === true) : result.some(item => item === true);
    };

    //# convert array to object, can convert with parameter
    public readonly arrToObj = (data: any[], prop?: string): any =>{
        let obj: any = {};
        data.forEach(item =>{
            prop ? obj[item[prop]] = item : obj[item] = item;
        });
        return obj;
    };

    //# convert array to object, can convert with parameter
    public readonly _arrToObj = (data: any[], prop?: string): any =>{
        let obj: any = {};
        data.forEach(item =>{
            prop ? obj['_' + item[prop]] = item : obj['_' + item] = item;
        });
        return obj;
    };

    //# convert array to object, can convert with parameter
    public readonly arrToObjMoment = (data: any[], prop: string, func?: string): any =>{
        let obj: any = {};
        data.forEach(item =>{
            try{
                prop
                    ? func
                        ? item[prop][func]
                            ? obj[item[prop][func]()] = item
                            : obj[moment(item[prop])[func]()] = item
                        : obj[item[prop]] = item
                    : obj[item] = item;
            } catch (e){
                console.error(e, 'error')
                //console.error(moment(item[prop]).format(), 'isMoment')
            }
        });
        return obj;
    };

    //# convert object to array
    public readonly objToArr = (data: any): any[] =>{
        let arr: any[] = [];
        for (let prop in data){
            arr.push(data[prop]);
        }
        return arr;
    };

    /**
     * Get unique values from simple array or array of objects
     * @param data array
     * @param prop property of object in array
     */
    public readonly getUniqueFromArr = (data: any[], prop?: string): any[] => {
        let obj = this.arrToObj(data, prop);
        return this.objToArr(obj);
    }

    /**
     * separate string, and trim separated values
     * @param data - string
     * @param separator
     */
    public readonly separate = (data: string, separator: string): string[] => data ? data.split(separator).map(item => item.trim()) : [];

    public readonly multipleSeparate = (data: string, separator: string[]): string[] => {
        let res: string[] = null;
        separator.forEach(item => {
            if (res === null){
                res = this.separate(data, item);
            } else if (Array.isArray(res)){
                let tmpRes = [];
                res.forEach( r => tmpRes = tmpRes.concat(this.separate(r, item)));
                res = tmpRes;
            }
        })
        return res;
    }

    //# parse string to number, if cant convert return null
    public readonly customParseNumber = (data: string): number => {
        let res: number;
        if (data) data = data.replace(/,/g, '.');
        res = data === '' ? null : Number(data);
        // res = isNaN(res) || data === null ? null : res;
        return data === null ? null : res;
        //return res;
    };

    //# set first letter to upperCase
    public readonly upperCaseFirstLetter = (str: string): string => {
        return str
            ? str.charAt(0).toUpperCase() + str.slice(1)
            : '';
    }

    //# set first letter to lowerCase
    public readonly lowerCaseFirstLetter = (str: string): string => {
        return  MainHelper.lowerCaseFirstLetter(str)
    }

    //# set first letter to lowerCase
    public static readonly lowerCaseFirstLetter = (str: string): string => {
        return str
            ? str.charAt(0).toLowerCase() + str.slice(1)
            : '';
    }

    //# regex for find tags
    public readonly regExpFindTags: RegExp = /(<([^>]+)>)/ig;

    //# return date format based on localization
    public readonly getLocale = (loc: string): string => {
        switch (loc){
            case 'ru': return MainHelper.ru_Date;
            case 'en': return MainHelper.ru_Date;
            case 'uk': return MainHelper.ru_Date;
            case 'ua': return MainHelper.ru_Date;
            case 'lt': return MainHelper.ru_Date;
            default: return MainHelper.ru_Date;
        }
    }

    //# return date format based on localization
    public readonly getShortLocale = (loc: string): string => {
        switch (loc){
            case 'ru': return MainHelper.ru_DateShort;
            case 'en': return this.en_DateShortInput;
            case 'uk': return MainHelper.ru_DateShort;
            case 'ua': return MainHelper.ru_DateShort;
            case 'lt': return MainHelper.ru_DateShort;
            default: return MainHelper.ru_DateShort;
        }
    }

    public static readonly ru_Date: string = 'DD.MM.YYYY';
    public static readonly ru_DateFile: string = 'DDMMYYYY';
    public static readonly ru_DateShort: string = 'DD.MM.YY';
    public static readonly ru_DateTime: string = 'DD.MM.YYYY HH:mm:ss';
    public static readonly ru_Time: string = 'HH:mm:ss';

    public readonly en_Date: string = 'YYYY.MM.DD';
    public readonly en_DateInput: string = 'DD.MM.YYYY';
    public readonly en_DateShort: string = 'YY.MM.DD';
    public readonly en_DateShortInput: string = 'DD.MM.YY';
    public readonly en_DateTime: string = 'YYYY.MM.DD HH:mm:ss';
    public readonly en_Time: string = 'HH:mm:ss';
    public readonly input_Date: string = 'YYYY-MM-DD';
    public static readonly dateFormat: string = 'YYYY-MM-DD';
    public static readonly timeFormat: string = 'HH:mm:ss';
    public static readonly dateTimeFormat: string = 'YYYY-MM-DD HH:mm:ss';

    //# remove more than one element from array
    public readonly remFromArrSimple = (arr: any[], val: string | boolean | number, equals: boolean = true): any[] =>{
        let idx: number[] = [];
        equals
            ? arr.forEach((item, i) => item === val ? idx.push(i) : null)
            : arr.forEach((item, i) => item !== val ? idx.push(i) : null);

        idx.reverse();
        idx.forEach(item => arr.splice(item, 1));
        return  arr;
    };

    //# remove more than one element from array
    public readonly remFromArr = (arr: any[], prop: string, val: string | boolean | number, equals: boolean = true): any[] =>{
        let idx: number[] = [], removed: any[] = [];
        equals
            ? arr.forEach((item, i) => item[prop] === val ? idx.push(i) : null)
            : arr.forEach((item, i) => item[prop] !== val ? idx.push(i) : null);

        idx.reverse();
        idx.forEach(item => removed.push(arr.splice(item, 1)[0]));
        return removed;
    };

    //# remove more than one element from array
    public readonly remFromArrArr = (arr: any[], prop: string, val: string[] | boolean[] | number[], equals: boolean = true): any[] =>{
        let idx: number[] = [], deleted: any[] = [];
        equals
            ? arr.forEach((item, i) => (val as Array<any>).some(inItem => item[prop] === inItem) ? idx.push(i) : null)
            : arr.forEach((item, i) => (val as Array<any>).some(inItem => item[prop] !== inItem) ? idx.push(i) : null);

        idx.reverse();
        idx.forEach(item => deleted.push(arr.splice(item, 1)));
        return deleted;
    };

    //# remove more than one element from array
    public readonly remFromArrArrSimple = (arr: any[], val: string[] | boolean[] | number[], equals: boolean = true): any[] =>{
        let idx: number[] = [];
        equals
            ? arr.forEach((item, i) => (val as Array<any>).some(inItem => item === inItem) ? idx.push(i) : null)
            : arr.forEach((item, i) => (val as Array<any>).some(inItem => item !== inItem) ? idx.push(i) : null);

        idx.reverse();
        idx.forEach(item => arr.splice(item, 1));

        return arr;
    };

    //# remove more than one element from array
    public readonly remFromArrJoin = (arr: any[], prop: string, val: string[] | boolean[] | number[], equals: boolean = true) =>{
        let idx: number[] = [];
        equals
            ? arr.forEach((item, i) => (val as Array<any>).every(inItem => item[prop] !== inItem) ? idx.push(i) : null)
            : arr.forEach((item, i) => (val as Array<any>).every(inItem => item[prop] === inItem) ? idx.push(i) : null);

        idx.reverse();
        idx.forEach(item => arr.splice(item, 1));
    };

    //# remove more than one element from array
    public readonly remFromArrArrComplex = (arr: any[], prop: string, prop2: string, val: string[] | boolean[] | number[], equals: boolean = true) =>{
        let idx: number[] = [];
        equals
            ? arr.forEach((item, i) => (val as Array<any>).some(inItem => item[prop][prop2] === inItem) ? idx.push(i) : null)
            : arr.forEach((item, i) => (val as Array<any>).some(inItem => item[prop][prop2] !== inItem) ? idx.push(i) : null);

        idx.reverse();
        idx.forEach(item => arr.splice(item, 1));
    };

    //# encode number to css class, foe highlight slickgrid sells
    public readonly getClass = (id: number): string => {
        switch (id){
            case 0: return '';
            case 1: return 'yellow-black';
            case 2: return 'white-green';
            case 3: return 'white-green-bold';
            case 4: return 'white-red';
            case 5: return 'blue-white';
            case 6: return 'red-black';
            case 7: return 'green-black';
            case 8: return 'lightblue-black';
            case 9: return 'burgundy-green-bold';
            case 10: return 'burgundy-orange-bold';
            case 11: return 'blue-black-bold';
            case 12: return 'black-white-bold';
            case 13: return 'red-white';
            case 14: return 'burgundy-white-bold';
            case 15: return 'black-white';
            case 16: return 'gray-white';
            case 17: return 'purple-white';
            case 18: return 'orange-black';
            case 19: return 'just-bold';
            case 20: return 'light-blue-black-2';
            case 21: return 'orange-black-h-dark';
            default: return ''
        }
    };

    //# forEach for html collection
    public readonly forEachHtml = (func: (item?: HTMLElement, i?: number, col?: HTMLCollection) => void, col: HTMLCollection) =>{
        for (let i = 0; i < col.length; i++){
            if (func){
                func(col[i] as HTMLElement, i, col);
            }
        }

    };

    //# remove non unique elements from array, very fast
    public readonly checkUniqueByObj = (data: string[]): string[] =>{
        let obj: any = {},
            arr: string[] = [];
        data.forEach((item, i) =>{
            if (!obj[item.toLowerCase()]) {
                obj[item.toLowerCase()] = {data: item, index: i};
            }
        });
        for (let prop in obj){
            arr[obj[prop].index] =  obj[prop].data;
        }
        arr = arr.filter(item => item);
        return arr;
    };

    //# remove non unique elements from number array, very fast
    public readonly checkUniqueByObjNumber = (data: number[]): number[] =>{
        let obj: any = {},
            arr: number[] = [];
        data.forEach((item, i) =>{
            if (!obj[item]) {
                obj[item] = {data: item, index: i};
            }
        });
        // console.log(data, obj, 'checkUniqueByObjNumber')
        for (let prop in obj){
            arr[obj[prop].index] =  obj[prop].data;
        }
        arr = arr.filter(item => item);
        return arr;
    };

    //# remove non unique elements from number array, very fast
    public readonly checkUniqueByObjComplex = (data: any[], prop: string): any[] =>{
        let obj: any = {},
            arr: number[] = [];
        data.forEach((item, i) =>{
            if (!obj[item[prop]]) {
                obj[item[prop]] = item;
            }
        });
        // console.log(data, obj, 'checkUniqueByObjNumber')
        for (let prop in obj){
            arr.push(obj[prop])
        }

        return arr;
    };

    //# copy obj without methods
    public readonly deepCopy = (obj: any, prop?: string): any => {
        let copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;

        if (prop && 'undefined' === typeof obj[prop]){
            return null;
        }

        if (prop){
            obj = obj[prop];
        }



        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
            }
            return copy;
        }

        console.log("Unable to copy obj! Its type isn't supported.")
        // throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    public readonly deepCopyGrouping = (obj: Slick.Group<any>, prop: string, idField?: string[]): any => {
        let copy: any = {};

        copy[prop] = 'undefined' === typeof obj[prop] ? null : obj[prop];
        copy['groupingKey'] = obj['groupingKey'];

        if (obj.rows && obj.rows.length){
            let rows: any[] = [];
            obj.rows.forEach(r => {
                let copiedRow = {};
                copiedRow[prop] = r[prop] instanceof Object || r[prop] instanceof Date || r[prop] instanceof Array
                    ? this.deepCopy(r, prop)
                    : r[prop];
                idField && idField.length && idField.forEach(id => copiedRow[id] = r[id])
                // console.log(idField, copiedRow, 'deepCopyGrouping')
                rows.push(copiedRow)
            });
            copy['rows'] = rows;
        }
        return copy;
    }

    public readonly deepCopyCustomProp = (obj: any): any => {
        let copy;


    }

    //# create popper, check for all element or references exist
    public readonly popperAdd = (refElIn: ElementRef | Element,
                                 popperElIn: ElementRef | Element,
                        boundariesIn: ElementRef | Element,
                        placement: string, behavior: string[], getParent: boolean
    ): Popper =>{
        let refEl: Element = refElIn && (refElIn as ElementRef).nativeElement ? (refElIn as ElementRef).nativeElement : (refElIn as Element),
            popperEl = getParent
                ? popperElIn && (popperElIn as ElementRef).nativeElement ? (popperElIn as ElementRef).nativeElement.parentElement : (popperElIn as Element).parentElement
                : popperElIn && (popperElIn as ElementRef).nativeElement ? (popperElIn as ElementRef).nativeElement : (popperElIn as Element),
            boundaries = boundariesIn && (boundariesIn as ElementRef).nativeElement ? (boundariesIn as ElementRef).nativeElement : (boundariesIn as Element);

        let popper = new Popper(refEl, popperEl,{
            placement: placement,
            positionFixed: true,
            modifiers: {
                flip: {
                    behavior: behavior
                },
                preventOverflow: {
                    boundariesElement: boundaries,
                    padding: 0
                },
            },
        });

        this.wait(() => popper.update(), 5);

        return popper;
    };

    //# get width of all child elements
    public readonly getInnerWidth = (el: any): number => {
        let datesChildren = el.children,
            datesWrpWidth: number = 0;

        for (let i = 0; datesChildren.length > i; i++){
            datesWrpWidth += datesChildren[i].offsetWidth;
        }

        datesWrpWidth += this.removePx($(el).css("padding-left")) + this.removePx($(el).css("padding-right"));

        //datesWrpWidth = Number(datesWrpWidth.toString())

        return datesWrpWidth;
    }

    //# get list of columns which need be styled
    public readonly getListStyledColumns = (data: any[]): string[] =>{
        let result: string[] = [],
            idx: number = null;
        data.some((row, i) => {
            if (!row.__group){
                idx = i;
                return true
            }
        })

        if (data && data.length && idx !== null){
            for (let prop in data[idx]){
                let found = prop.match(/[\w\-]+Style/);
                if (found){
                    result.push(found[0].replace(/Style/g, ''));
                }
            }
        }
        return result;
    }

    //# get rows from grid dataView filtered
    public readonly getRowsFromGrid = (gridView: Slick.Data.DataView<any>): any[] => {
        let filteredLength = gridView.getLength(),
            rows = [],
            items = [];

        for (let i = 0; i < filteredLength; i++){
            rows.push(i)
        }

        for (let i = 0; i < rows.length; i++){
            items.push(gridView.getItem(i));
        }

        return items;
    };

    //# get rows from grid dataView filtered with groups
    public readonly getRowsFromGridAll = (gridView: Slick.Data.DataView<any>): any[] => {
        let items = this.getRowsFromGrid(gridView),
            rows: any[] = [],
            hasGroups = items.some(item => item.__group);

        if (hasGroups){
            let itemsInsideGrp: any[] = [];
            items.forEach(item => {
                if (item.__group && item.level === 0 && item.rows && item.rows.length){
                    item.rows.forEach(row => itemsInsideGrp.push(row))
                }
            });

            rows = itemsInsideGrp;
        } else {
            rows = items;
        }

        if (!rows.length){
            rows = [];
        }

        return rows;
    };

    //# get rows from grid dataView fully
    public readonly getRowsFromGridFull = (gridView: Slick.Data.DataView<any>): any[] => {
        let items = gridView.getItems(),
            rows: any[] = [],
            hasGroups = items.some(item => item.__group);

        if (hasGroups){
            let itemsInsideGrp: any[] = [];
            items.forEach(item => {
                if (item.__group && item.level === 0){
                    itemsInsideGrp = itemsInsideGrp.concat(item.rows);
                }
            });

            rows = itemsInsideGrp;
        } else {
            rows = items;
        }

        if (!rows.length){
            rows = [];
        }

        return rows;
    };

    //# set sell styles for grid
    public readonly setCellStyles = (gridView: Slick.Data.DataView<any>, stylesObj?: any): any =>{
            let mainStyles = null,
                items = this.getRowsFromGrid(gridView),
                columnsList: string[] = this.getListStyledColumns(items);
            items.forEach((row, i) => mainStyles = this.setCellMainStyles(mainStyles, row, i, columnsList));

            const styles = {};

            if (mainStyles === null) mainStyles = {};
            styles['main-styles'] = mainStyles;

            if (mainStyles && stylesObj){
                    stylesObj['main-styles'] = mainStyles;
                    let temp = stylesObj;
                    stylesObj = {};
                    stylesObj = temp;
            } else {
                return styles;
            }
    };

    //# remove pixels from string
    public removePx = (val: string): number => {
        return parseInt(val, 10);
    }

    //# set sell styles for row
    public readonly setCellMainStyles = (hash: Slick.CellCssStylesHash, row: any, index: number, columnsList: string[]): Slick.CellCssStylesHash =>{
        let styles = null;

        if (row.__group){
            styles = {};
        } else{
            columnsList.forEach(item =>{
                let className = this.getClass(row[`${item}Style`]),
                    obj = {};
                obj[item] = className;
                styles = Object.assign(styles || {}, obj);
            });
        }

        if (!styles)
            return hash;

        if (!hash)
            hash = {};
        hash[index] = styles;

        return hash;
    };

    public readonly insideGroupChanges = (cellCssStyles: {[key: string]: CellCssStylesHash}, view: Slick.Data.DataView<any>): void => {

        if (cellCssStyles['changed-cells']){
            let changed = cellCssStyles['changed-cells'];
            for (let row in changed){
                if (changed[row]){
                    for (let prop in changed[row]){
                        // console.log(prop, this.view.getItem(parseInt(row)) , 'prop')
                        if (view.getItem(parseInt(row)).groupingKey){
                            this.wait(() => {
                                // console.log(prop, this.view.getItem(parseInt(row)), this.view.getItem(parseInt(row))[prop],
                                //     (this.view.getItem(parseInt(row)) as Slick.Group<IPMainData>).rows.map(r => r[prop]), 'items[parseInt(row)]')
                                let notEqual = (view.getItem(parseInt(row)) as Slick.Group<IPMainData>).rows.some(
                                    r => view.getItem(parseInt(row))[prop] !== r[prop]
                                );
                                if (notEqual){
                                    changed[row][prop] += ' in-grp-change'
                                }
                            }, 90)
                        }
                    }
                }
            }
        }
    }

    //# remove time from date for comparison
    public readonly removeTime = (date: Date): number => {
        return date.setHours(0, 0, 0, 0);
    }

    public readonly groupBy = (xs: any[], key: string): object => {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    public readonly generateNgClass = (inClass: string[]): {[index: string]: boolean} =>{
        if (inClass && inClass.length){
            let inputClass = {};
            inClass.forEach(item => inputClass[item] = true);
            return inputClass;
        } else {
            return {}
        }
    }

    public readonly updateArrGUID = (behavior: BehaviorSubject<any>, item: GUID): void => {
        let arr: GUID[] = behavior.getValue();
        if (!arr){
            // arr = [];
        }
        let set: boolean = arr.some((inItem, i, inArr) => {
            if (inItem.GUID === item.GUID){
                inArr[i] = item;
                return true;
            }
        });
        !set ? arr.push(item) : null;

        behavior.next(arr);
    }

    public readonly updateArrGUID2 = (arr: GUID[], item: GUID): GUID[] => {

        if (!arr){
            // arr = [];
        }

        if (arr[0]){
            // console.log(arr[0].GUID, 'updateArrGUID')
        }

        // console.log(arr, 'updateArrGUID')

        let set: boolean = arr.some((inItem, i, inArr) => {
            if (inItem.GUID === item.GUID){
                inArr[i] = item;
                return true;
            }
        });
        !set ? arr.push(item) : null;

        return arr
    }

    public readonly getGUIDObj = (arr: GUID[], GUID: string): any => {
        if (!arr || !Array.isArray(arr) || !GUID){
            return null
        }
        return arr.find(item => item.GUID === GUID);
    }

    public readonly compareSimpleObj = (obj1: any, obj2: any): boolean => {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    public readonly findDifferenceInSimpleObj = (obj1: any, obj2: any): void => {
        for (let prop in obj1){
            if (JSON.stringify(obj1[prop]) !== JSON.stringify(obj2[prop])){
                console.log(prop, obj1[prop], obj2[prop], 'first obj')
            }
        }

        for (let prop in obj2){
            if (JSON.stringify(obj1[prop]) !== JSON.stringify(obj2[prop])){
                console.log(prop, obj1[prop], obj2[prop], 'second obj')
            }
        }
    }

    public readonly compareStocksFilters = (filter1: any, filter2: any): boolean => {
        let hasDifference: boolean = false;

        const checkEmpty = (val: any): boolean => {
            return val === null || val === '' || typeof val === 'undefined'
        }
        const checkDiff = (filter: any): void => {
            for (let prop in filter){
                if (JSON.stringify(filter1[prop]) !== JSON.stringify(filter2[prop])){
                    if (checkEmpty(filter1[prop]) && checkEmpty(filter2[prop])){

                    } else {
                        hasDifference = true;
                    }
                }
            }
        }

        checkDiff(filter1);
        checkDiff(filter2);
        return hasDifference;
    }

    public readonly tryCatch = (func: Function): void => {
        try{
            func();
        } catch (e){
            console.error(e);
        }
    }

    //# translate data for filters in main filter
    public readonly translateData = async (data: any[], translateService: TranslateService, keyField: string, translatedField: string): Promise<any[]> => {
        // keyField = !keyField ? 'name' : keyField;
        if (data && data.length > 0) {
            let translates: string[] = data.map(item => item[keyField]);

            let res: any = await translateService.get(translates).toPromise();
            // console.log(translates, res, 'translateData')
            for (let i = 0; i < data.length; i++){
                data[i][translatedField] = res[data[i][keyField]];
            }
        }
        return data;
    };

    public readonly tooltipFunc: Function = new Function('cell', '$("[data-toggle=tooltip]", cell).tooltip({ boundary: "window" });');

    public readonly tooltipFunc2: Function = new Function('$("[data-toggle=tooltip]").tooltip({ boundary: "window" });');

    public readonly generateCssClass = (inClass: string[]): {[index: string]: boolean} =>{
        let inputClass: {[index: string]: boolean} = {};
        inClass && inClass.length && inClass.forEach(item => inputClass[item] = true);
        return inputClass
    }

    //# hides tooltip
    public readonly remTooltip = (e: MouseEvent): void => {
        // (e.target as HTMLElement).blur();
        let el: HTMLElement = (e.target as HTMLElement),
            closeTooltip = false;
        while (el){
            if (el.getAttribute('data-toggle') === 'tooltip'){
                closeTooltip = true;
                break;
            }

            el = el.parentElement;
        }

        if (closeTooltip){
            // console.log(el, 'remTooltipWait')
            $(el).tooltip('hide')
            // $(el).tooltip('disable')
            //  this.wait(() => $(el).tooltip('enable'), 30000)

        }
    }

    //# hides tooltip
    public readonly remTooltipWait = (e: MouseEvent): void => {
        let el: HTMLElement = (e.target as HTMLElement),
        closeTooltip = false;
        this.wait(() => {
            this.remTooltip(e);
        }, 1000)
    }

    //# Super hide tooltip
    public readonly remTooltipWaitMulti = (e: MouseEvent): void => {
        console.log(e);
        for (let i = 1; i < 10; i++){
            this.remTooltipWait(e)
            // this.wait(() => {
            //     (e.target as HTMLElement).blur();
            //     $(e.target).tooltip('hide')
            // }, i*500)
        }
    }

    public readonly showError = (e: any, errorShow:() => void): void => e === 401 ? console.error(401) : errorShow();

    //# check have ane selected aggregation in obj
    public readonly hasSelectedAg = (fnAggregation: AggregationSelector): boolean => {
        for (let prop in fnAggregation.data){
            if (fnAggregation.data[prop]){
                return true;
            }
        }
        return false;
    };

    //# copy aggregation selector
    public readonly copyAggregatorSelector = (agg: AggregationSelector): AggregationSelector => {
        return new AggregationSelector(agg.id, agg.name, new Aggregation(agg.data.sum, agg.data.avg, agg.data.min, agg.data.max));
    };

    //# styles for popup
    public popupStyle: string[] = [];

    //# show error popup
    public readonly errorPopup = (commonData: CommonDataService, messages: string[], onOk?: () => void) :void => {
        let options = new DialogOptions();
        commonData.showExErrors(
            this.popupStyle,
            'ErrorModalHeader',
            options,
            messages,
            onOk
        )
    }

    //# show error popup
    public readonly errorPopupTranslate = (translateService: TranslateService, commonData: CommonDataService, keys: string[], onOk?: () => void) :void => {
        translateService.get(keys).subscribe(t => this.errorPopup(commonData, keys.map(item => t[item]), onOk));
    }

    //# show info popup
    public readonly infoPopup = (commonData: CommonDataService, messages: string[], onOk?: () => void) :void => {
        let options = new DialogOptions();
        commonData.showExInfo(
            this.popupStyle,
            'InfoModalHeader',
            options,
            messages,
            onOk
        )
    }

    //# show question popup translate
    public readonly questionPopupTranslate = (translateService: TranslateService, commonData: CommonDataService, translateKeys: string[], options: DialogOptions, onYes: () => void, onNo?: () => void, onCancel?: () => void) :void => {
        translateService.get(translateKeys).subscribe(t => {
            let messages: string[] = []
            translateKeys.forEach( tk => messages.push(t[tk]))
            this.questionPopup(commonData, messages, options, onYes, onNo, onCancel);
        })
    }


    //# show question popup
    public readonly questionPopup = (commonData: CommonDataService, messages: string[], options: DialogOptions, onYes: () => void, onNo?: () => void, onCancel?: () => void) :void => {
        // let options = new DialogOptions();
        commonData.showExQuestions(
            this.popupStyle,
            'QuestionModalHeader',
            options,
            messages,
            onYes,
            onNo,
            onCancel
        )
    }

    //# after checking fist column with checkboxes added, after you can choose items, and all next work will be carried with selected items
    public readonly addCheckBoxColumn = (columns: Slick.Column<any>[], cssClass? :string, sortable: boolean = false, minWidth: number = 25): void =>{
        if (!columns || columns[0].id == 'selected'){
            return;
        }

        let column: Slick.Column<any> = {
            id: 'selected',
            field: 'selected',
            name: '<div class="out-chkb-wrp"><label class="chkb-wrp"><input tabIndex="-1" type="checkbox"><span></span></label></div>',
            sortable: sortable,
            width: 25,
            minWidth: minWidth,
            formatter: (r, c, v) => Formatters.checkBoxFormatter(r, c, v),
            selectAll2: true,
            type: 'boolean'
        }

        if (cssClass){
            column.headerCssClass = cssClass;
            column.cssClass = cssClass;
        }

        column.excelCellBlock = false;

        columns.unshift(column);
    };

    /**
     * Generate checkbox column
     */
    public readonly genCheckBoxColumn = (sortable?: boolean): Slick.Column<any> => {
        return {
            id: 'selected',
            field: 'selected',
            name: '<div class="out-chkb-wrp"><label class="chkb-wrp"><input tabIndex="-1" type="checkbox"><span></span></label></div>',
            sortable: sortable,
            width: 20,
            formatter: (r, c, v) => Formatters.checkBoxFormatter(r, c, v),
            selectAll2: true,
            type: 'boolean'
        }
    }

    /**
     * Generate remove column
     * @param tooltip - tooltip for
     * @param cssClass
     */

    //# after checking fist column with checkboxes added, after you can choose items, and all next work will be carried with selected items
    public readonly generateRemColumn = (tooltip: string, cssClass? :string): Slick.Column<any> =>{

        const formatCell = (): string => {
            return '<span class="fa-solid fa-xmark" data-toggle="tooltip" title="' + tooltip + '" style="cursor: pointer"></span>'
        };

        let column: Slick.Column<any> = {
            id: 'remove',
            field: 'remove',
            name: '',
            sortable: false,
            width: 20,
            formatter: (r, c, v) => formatCell(),
            type: 'boolean'
        }

        if (cssClass){
            column.headerCssClass = cssClass;
            column.cssClass = cssClass;
        }

        column.excelCellBlock = false;

        return column
    };

    //# after checking fist column with checkboxes added, after you can choose items, and all next work will be carried with selected items
    public readonly addDelColumn = (tooltip: string, cssClass? :string, icon?: string): Slick.Column<any> =>{

        const formatCell = (): string => {
            return `<span class="${ icon ? icon : 'fa-solid fa-trash-can' }" title="${ tooltip }" style="cursor: pointer"></span>`
        };

        let column: Slick.Column<any> = {
            id: 'remove',
            field: 'remove',
            name: `<span class="${ icon ? icon : 'fa-solid fa-trash-can' }"></span>`,
            sortable: false,
            width: 20,
            formatter: (r, c, v) => formatCell(),
            type: 'boolean'
        }

        if (cssClass){
            column.headerCssClass = cssClass;
            column.cssClass = cssClass;
        }

        column.excelCellBlock = false;

        return column
    };

    //# convert boolean to yes or no? and set header
    public setBooleanColumn = (columns: ExportExcelColumn[], mainRows: any[], header: string, yes: string, no: string, boolColumn?: string): any[] => {
        let field = boolColumn ? boolColumn : 'selected',
        selected = columns.find(item => field === item.field);
        if (selected) {
            selected.header = header;
            mainRows.forEach(item => {
                item[field] ? item[field] = yes : item[field] = no
            } );
        }
        // console.log(mainRows, 'mainRows')
        return mainRows;
    }

    //# generate aggregation view in view grid
    public totalsFormatter = (totals, columnDef: Slick.Column<any>): string =>{

        let sumVal = totals.sum && totals.sum[columnDef.field],
            avgVal = totals.avg && totals.avg[columnDef.field],
            minVal = totals.min && totals.min[columnDef.field],
            maxVal = totals.max && totals.max[columnDef.field],
            result: string = '';

        const customRound = (data: number): number =>{
            return Math.round(data * 100) / 100;
        };

        if (avgVal != null){
            result += "Avg: " + customRound(avgVal);
        }

        if (sumVal != null){
            // result = avgVal != null ? result + '; ' : result;
            result = result ? result + '; ' : result;
            result += "Sum: " + customRound(sumVal);
        }

        if (minVal != null){
            // result = avgVal != null || sumVal != null ? result + '; ' : result;
            result = result ? result + '; ' : result;
            result += "Min: " + customRound(minVal);
        }

        if (maxVal != null){
            // result = avgVal != null || sumVal != null || minVal != null ? result + '; ' : result;
            result = result ? result + '; ' : result;
            result += "Max: " + customRound(maxVal);
        }

        if (avgVal != null || sumVal != null || minVal != null || maxVal != null){
            let title = totals.group.title.replace(this.regExpFindTags, "");
            // result += `; ${totals.group.title}`;
            result = `<span title="${title}">${result}</span>`;
        }
        return result;
    };

    public readonly getStringActivity = (activity: number): string => {
        switch (activity){
            case 0: return 'OLD';
            case 1: return 'MTS';
            case 2: return 'MTO';
            case 3: return 'OUT';
        }
    }

    public readonly getMaxOfArray = (numArray): number => {
        return Math.max.apply(null, numArray);
    }
    /**
     * Create number array from start number to end number
     * @param start
     * @param end
     */
    public readonly generateNumberArr = (start: number, end: number): number[] =>{
        let arr: number[] = [];
        for (let i = start; i < end + 1; i++){
            arr.push(i)
        }
        return arr
    }

    /**
     * Add to exist translate obj new translates
     * @param translateService - Translate service
     * @param needToTranslate - string array, with translate keys
     * @param translates obj with existed translates
     */
    public readonly updateTranslates = async (translateService: TranslateService, needToTranslate: string[], translates: {[key: string]: string}): Promise<{[key: string]: string}> => {
        let newTranslates = await translateService.get(needToTranslate).toPromise();
        for (let translate in newTranslates){
            translates[translate] = newTranslates[translate];
        }

        return translates;
    }

    public readonly moveElInArr = (arr: any[], old_index: number, new_index: number): void => {
        if (new_index >= arr.length) {
            let k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        //return arr; // for testing
    };

    public readonly getPadding = (element: HTMLElement | ElementRef): IndentSize  => {
        if (!element){
            return null;
        }

        let el: any = element && (element as ElementRef).nativeElement ? (element as ElementRef).nativeElement : (element as Element)
        let style = el.currentStyle || window.getComputedStyle(el);

        let result: IndentSize = {
            top: parseInt(style.paddingTop),
            bottom: parseInt(style.paddingBottom),
            left: parseInt(style.paddingLeft),
            right: parseInt(style.paddingRight)
        }

        return result;
    }


    /**
     * Add tooltip to slickgrid cells
     * @param cell - slickGrid cell - HTMLElement
     * @param container - container for tooltip
     * @param title - tooltip text
     * @param maxWidth - max width text
     * @param gridId - grid GUID
     */
    public readonly tooltipFuncGridAdd = (cell: HTMLElement, container: string, title: string, maxWidth: number, gridId: string): void => {

        const getHTMLClass = (maxWidth: number): string => {
            if (maxWidth > 550){
                return 'big-tooltip';
            } else if (maxWidth <= 550 && maxWidth > 350){
                return 'medium-tooltip';
            } else {
                return '';
            }
        }

        let tooltipOptions: TooltipOption = {
                placement: 'top',
                trigger: 'hover',
                offset: "0, 0",
                template: `<div style="z-index: 100" class="tooltip ${getHTMLClass(maxWidth)} ${gridId}-grid-gen-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`,
                // boundary: $(container)[0],
                boundary: document.body,
                html: true,
                title: title,
            };

        // console.log(maxWidth, tooltipOptions.template, 'tooltipFuncGridAdd')

        cell.setAttribute('data-toggle', 'tooltip')
        $(cell).tooltip(tooltipOptions);
        $(cell).tooltip('show');
    }

    /**
     * Remove tooltip to slickgrid cells
     * @param cell - slickGrid cell - HTMLElement
     */
    public readonly tooltipFuncGridRem = (cell: HTMLElement): void => {
        $(cell).tooltip('dispose');
        // $(cell).attr("title", '');
    }

    /**
     * save sorting to localStorage
     * @param args slickgrid event notify sorting
     * @param storageKey key for save on localstorage
     */
    public saveSorting = (args: EventArgs<Slick.OnSortEventArgs<any>>, storageKey: string): void =>{
        args
            ? localStorage[storageKey] = JSON.stringify({columnId: args.data.sortCols[0].sortCol.id, field: args.data.sortCols[0].sortCol.field, sortAsc: args.data.sortCols[0].sortAsc})
            : localStorage.removeItem(storageKey)
    };

    /**
     * load sort data from localStorage
     * @param storageKey key for load data from localstorage
     */
    public readonly getDataFromLS = (storageKey: string): any =>{
        try{
             return JSON.parse(localStorage[storageKey]);
        } catch (e){
            return null;
        }
    }

    /**
     * load simple data from localStorage or default value
     * @param storageKey key for load data from localstorage
     * @param defaultValue default value for return
     */
    public readonly getDataFromLSSimple = (storageKey: string, defaultValue: string): string =>{
        try{
            return localStorage.getItem(storageKey) === null ? defaultValue : localStorage.getItem(storageKey);
        } catch (e){
            return null;
        }
    }

    /**
     *
     * @param sort obj with prop and sort type
     * @param data data for sort
     * @param sorter custom sorter
     * @param grid slickgrid for sort
     */
    public readonly sortDataInObjArray = (
        sort: {field: string, columnId: string, sortAsc: boolean},
        data: any[],
        sorter: DataSorter<any> = new DataSorter<any>(),
        grid: SlickGridComponent = null
    ): boolean =>{

        if (sort && data && data.length){
            if (!!grid && !!sorter){
                let event: any = {
                    sortCol: {id: sort.columnId, field: sort.field},
                    sortAsc: sort.sortAsc,
                    sortCols: null,
                    grid: grid,
                }
                sorter.sort(event);
            } else {
                data.sort((a, b) => sorter.defaultCompare(a, b, sort.field));
                if (!sort.sortAsc){
                    data = data.reverse();
                }
            }
            return true;
        } else {
            return false;
        }
    };

    //# sort data in grid from localStorage
    public readonly sortDataFromLSInGrid = (storageKey: string, data: any[], grid?: SlickGridComponent, sorter?: DataSorter<any>): void =>{
        let sort: {field: string, columnId: string, sortAsc: boolean} = this.getDataFromLS(storageKey);
        if (grid){
            // console.log(grid, 'sortDataFromLSInGrid')
            this.sortDataInObjArray(sort, data, sorter, grid) && grid.setSortColumn(sort.columnId, sort.sortAsc);
        } else {
            this.sortDataInObjArray(sort, data, sorter)
        }

    };

    public readonly sortDataFromLS = (storageKey: string, data: any[]): void => {
        let sort: {columnId: string, sortAsc: boolean} = this.getDataFromLS(storageKey);
    }

    /**
     *
     */
    public readonly activateEditorOnClick  = (args: EventArgs<Slick.OnClickEventArgs<any>>): void => {
        let grid = args.data.grid;
        grid.setActiveCell(args.data.row, args.data.cell);
        this.wait(() => grid.editActiveCell(null))
    }

    public get fresh(): typeof Fresh{
        return Fresh;
    }

    public readonly getTranslatedStatus = async (data: any[], fieldName: string[], translateService: TranslateService, separator? : string): Promise<void> =>{

        data.forEach(async (itemMain, fn) => {
            if (itemMain.length === 0) return;

            const statusObj = {};
            itemMain.forEach((item, i) =>{
                let innerStatus = item[fieldName[fn]].split(separator ? separator : ',');
                innerStatus = innerStatus.map(item => item.trim());
                innerStatus.map(r => statusObj[r] = '');
            });

            const statusArr = [];
            for (let error in statusObj){
                statusArr.push(error)
            }

            let result = await translateService.get(statusArr).toPromise();

            this.translateStatus(itemMain, result, fieldName[fn], separator);
        });

    };

    public readonly translateStatus = (ExcelData: ActionPlusExcelChecked[], res: any, fieldName: string, separator?: string) =>{

        ExcelData.forEach((item, i) =>{

            let status = item[fieldName].split(separator ? separator : ',');
            status = status.map(item => item.trim());

            const statusObjItem = {};

            status.map(r => statusObjItem[r] = '');
            item[fieldName] = '';
            let lastProperty = Object.keys(statusObjItem)[Object.keys(statusObjItem).length - 1];
            for (let property in statusObjItem){
                if (lastProperty === property){
                    item[fieldName] += res[property] + ';';
                } else{
                    item[fieldName] += res[property] + '; ';
                }
            }
        });
    };

    public readonly removeTags = (data: any[], statuses: string[]): any[] => {
        let regExp = this.regExpFindTags,
            clone = data.slice(0);
        clone.forEach(item => {
            statuses.forEach(s => item[s] = item[s].replace(regExp, ""))
        });
        return clone;
    };

    public readonly saveToLocalStorageJSON  = (key: string, data: any): void => {
        try{
            localStorage[key] = JSON.stringify({data: data});
        } catch (e){

        }
    }

    public readonly readFromLocalStorageJSON  = (key: string): any => {
        try{
            return JSON.parse(localStorage[key]).data;
        } catch (e){
            return null
        }
    }

    public readonly getDigitLength = (num: number): number => {
        return (num + '').replace('.', '').length;
    }

    public readonly validateDate = (date: string, locale?: string): boolean =>{
        if (!date){
            return true;
        }

        if(locale){
            return moment.utc(date, this.getShortLocale(locale),true).isValid();
        } else{
            return  moment.utc(date, true).isValid();
        }

    }

    public static readonly convertDate = (date: string | number, locale: string): string => {
        let dateConv: string, dateUTC: string, format: string;

        if (typeof date === 'number'){
            dateUTC = moment(date).subtract(new Date(date).getTimezoneOffset(), 'minutes').format();
        }

        format = ['ru', 'uk', 'lt', 'pl'].includes(locale)
            ? 'DD.MM.YYYY'
            : 'DD.MM.YYYY'

        dateConv = moment.utc(dateUTC ? dateUTC : date).format(format);
        // console.log(date, dateUTC, dateConv, 'convertDate')
        return dateConv == 'Invalid date' ? '' : dateConv;
    }

    public readonly getFilterTranslateObj = (corr: LocalizationCorrespondence[], translates: {[key: string]: string}): {[key: string]: string} => {
        let filterObj: {[key: string]: string} = {};
        corr.forEach(cr => filterObj[cr.number] = translates[cr.localisationKey]);
        return filterObj;
    }

    /**
     * Get localised description field
     * @param data list of registry strings
     * @param translates - object with translates
     * @param corr - settings for localization current string
     * @param fieldName - field which need to be localize
     */
    public readonly getLocalizedDescription = (data: any[], corr: LocalizationCorrespondence[], translates: {[key: string]: string}, fieldName: string): void => {
        let filterObj = this.getFilterTranslateObj(corr, translates);
        data.forEach(d => {
            let keys = d[fieldName].toString().split(';');
            d[fieldName] = '';
            if (keys){
                keys = keys.filter(k => k);
            }
            keys.forEach((a, i, arr) => d[fieldName] += `${filterObj[a] ? filterObj[a] : a}${arr.length > i + 1 ? '; ' : ''}`)
        })
    }

    /**
     * Get localized suffix for numbers with gender
     * @param num - number for suffix
     * @param weekDay - day of the week
     * @param locale - current language key
     */
    public readonly getSuffixWeekday = (num: number, weekDay: string, locale: string): string => {
        return this.getSuffixGender(num, this.getWeekdayGender(weekDay, locale));
    };

    /**
     * Get gender for weekday
     * @param weekDay - day of the week
     * @param locale - current language key
     */
    public readonly getWeekdayGender = (weekDay: string, locale: string): 'He' | 'She' | 'It' => {
        if (locale === 'uk'){
            if (['1', '2', '4',].includes(weekDay)){
                return 'He';
            } else {
                return 'She';
            }
        } else if (locale === 'ru'){
            if (['1', '2', '4'].includes(weekDay)){
                return 'He';
            } else if (['3', '5', '6'].includes(weekDay)) {
                return 'She';
            } else {
                return 'It';
            }
        } else{
            return 'It';
        }
    };

    /**
     * Get localized suffix for numbers with gender
     * @param num - number for suffix
     * @param gender - gender of the day
     */
    public readonly getSuffixGender = (num: number, gender: 'She' | 'He' | 'It'): string => {
        let suffix = `NumSuffix${gender}_10`;
        if (num == 0) suffix = `NumSuffix${gender}_0`;
        if (num % 10 == 1 && num % 100 != 11) suffix = `NumSuffix${gender}_1`;
        if (num % 10 == 2 && num % 100 != 12) suffix = `NumSuffix${gender}_2`;
        if (num % 10 == 3 && num % 100 != 13) suffix = `NumSuffix${gender}_3`;
        if ((num % 10 == 7 || num % 10 == 8) && num % 100 != 13 && num % 100 != 17 && num % 100 != 18) suffix = `NumSuffix${gender}_7_8`;

        return suffix;
    };

    public readonly dataItemColumnValueExtractor = (item: any, column: Slick.Column<any>): string => {
        return column.formatter ? column.formatter(null, null, item[column.field], column, item) : item[column.field];
    }

    public readonly getColumnsForExcelExport = (columns: Slick.Column<any>[]): ExportExcelColumn[] => {
        return columns.map(
            item => new ExportExcelColumn(
                item.name,
                item.field,
                item.excelCellBlock,
                item.grouping ? item.grouping.grouped : null,
                item.grouping && item.grouping.aggregation ? item.grouping.aggregation.data : null
            )
        );
    }

    public static readonly ruLocales: string[] = ['uk', 'lt', 'ru']

    public readonly prepareErrorTitle = () : string => {
        return 'width: 100%;' +
            ' text-align: center;' +
            ' font-size: 24px;' +
            ' display: inline-block;' +
            ' padding-left: 20px;' +
            ' padding-right: 20px;' +
            ' padding-bottom: 15px;' +
            ' line-height: 1.2;' +
            ' font-weight: bold;';
    }

    public readonly prepareErrorDesc = () : string => {
        return 'padding-left: 25px;' +
            ' padding-right: 25px;' +
            ' padding-bottom: 10px;' +
            ' display: inline-block;' +
            ' width: 100%;' +
            ' text-align: center;' +
            ' font-size: 16px;';
    }

    public readonly prepareErrorAsk = () : string => {
        return 'padding-left: 25px;' +
            ' padding-right: 25px;' +
            ' padding-bottom: 25px;' +
            ' display: inline-block;' +
            ' width: 100%;' +
            ' text-align: center;' +
            ' font-size: 16px;' +
            ' font-weight: bold;';
    }

    /**
     * Convert hex color to RGB
     * @param hex - hex color
     */
    public readonly hexColorToRGB = (hex: string): number[] => {
        hex = hex.substring(1);
        let aRgbHex = hex.match(/.{1,2}/g),
            aRgb = [
            parseInt(aRgbHex[0], 16),
            parseInt(aRgbHex[1], 16),
            parseInt(aRgbHex[2], 16)
        ];

        return aRgb;
    }

    public readonly checkDate = (currentDate: string, dateStr: string): boolean => {
        if (!dateStr){
            return false;
        }

        let date = new Date(dateStr),
            currDate = new Date(currentDate)

        return  currDate.getDate() === date.getDate() &&
                currDate.getMonth() === date.getMonth() &&
                currDate.getFullYear() === date.getFullYear()
    }

    /**
     * Get hours from time input
     * @param val - time from time input
     */
    public static readonly getHourFromInput = (val: string): number => {
        return Number(val.split(':')[0])
    }

    /**
     * Get minute from time input
     * @param val - time from time input
     */
    public static readonly getMinuteFromInput = (val: string): number => {
        return Number(val.split(':')[1])
    }

    public static readonly getWeekDays = (): string[] => {
        return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/main-helper.ts